import { useNavigate } from 'react-router';
import { useManageServiceQuoteCart } from '~/purchase/api';
import {
  IAddCartQuoteVariable,
  IQuoteCartAction,
  IQuoteCartAddServicePayload,
  IQuoteCartSubmitPayload,
  IRimType,
} from '~/purchase/types';

export const useServiceQuoteCart = () => {
  const manageCart = useManageServiceQuoteCart({
    submit: { enabled: true },
    addService: { enabled: true },
    updateServicePrices: { enabled: true },
    removeService: { enabled: true },
    reset: { enabled: true },
  });
  const navigate = useNavigate();

  const actions: IQuoteCartAction = {
    addService: {
      process: (data: IQuoteCartAddServicePayload, onSuccess?: () => void) => {
        manageCart.addService.mutate(data, {
          onSuccess: () => {
            onSuccess?.();
          },
        });
      },
      isLoading: manageCart.addService.isLoading,
    },
    updatePrice: {
      process: (
        data: {
          items?: Array<{ id: string; price: number }>;
          services?: Array<{ id: string; price: number }>;
        },
        onSuccess?: () => void,
      ) => {
        if (data.services) {
          manageCart.updateServicePrices.mutate(
            { services: data.services },
            {
              onSuccess: () => {
                onSuccess?.();
              },
            },
          );
        }
      },
      isLoading: manageCart.updateServicePrices.isLoading,
    },
    removeService: {
      process: (id: string) => {
        manageCart.removeService.mutate(id);
      },
      isLoading: manageCart.removeService.isLoading,
    },
    submit: {
      process: ({ payload, sendMail }) => {
        manageCart.submit.mutate(
          { ...(payload as IQuoteCartSubmitPayload), sendMail },
          {
            onSuccess: ({ data }) => {
              void navigate(`${data.reference}/submitted`);
            },
          },
        );
      },
      isLoading: manageCart.submit.isLoading,
    },
    updateRimType: {
      process: (_data: { rimType: IRimType }) => {},
      isLoading: false,
    },
    removeItem: {
      process: (_id: string, _payload?: IAddCartQuoteVariable) => {},
      isLoading: false,
    },
    updateItemQuantity: {
      process: (_id: string, _body: { quantity: number }) => {},
      isLoading: false,
    },
    addItem: {
      process: (_data: IAddCartQuoteVariable) => {},
      isLoading: false,
    },
    reset: {
      process: () => {
        manageCart.reset.mutate();
      },
      isLoading: manageCart.reset.isLoading,
    },
  };

  return { actions };
};
